import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="bulk-price"
export default class extends Controller {
  static values = {
    exchangeRate: Number,
  };

  static targets = [
    "basicBulkPriceEUR",
    "premiumBulkPriceEUR",
    "vipBulkPriceEUR",
    "eliteBulkPriceEUR",
  ];

  handleUpdate(e) {
    this.premiumBulkPriceEURTarget.value = e.target.value;
    this.vipBulkPriceEURTarget.value = e.target.value;

    this.premiumBulkPriceEURTarget.dispatchEvent(
      new Event("input", { bubble: true }),
    );
    this.vipBulkPriceEURTarget.dispatchEvent(
      new Event("input", { bubble: true }),
    );
  }
}
